import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const IMG_NSD = "https://images.pexels.com/photos/13801532/pexels-photo-13801532.jpeg?auto=compress&cs=tinysrgb&w=1400";
const IMG_LAS = "https://images.unsplash.com/photo-1539887523427-bb750641ad29?auto=format&fit=crop&w=1400&q=80";

const FEATURES = [
  {
    tag: "Signature · Serial",
    title: "National Service Diaries",
    copy: "One year, one uniform, a thousand awakenings. Real diaries from young Ghanaians on assignment across the country.",
    img: IMG_NSD,
    testid: "feature-national-service",
  },
  {
    tag: "Signature · Longform",
    title: "Life After School",
    copy: "What actually happens after the last exam? Career pivots, first paychecks, delayed dreams, and the maps nobody drew for us.",
    img: IMG_LAS,
    testid: "feature-life-after-school",
  },
];

export default function SignatureFeatures() {
  return (
    <section id="features" data-testid="signature-features" className="relative border-t border-[#2E1A6B]/15 bg-[#F4F4F0]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="mb-10 md:mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2E1A6B] mb-4">
            Signature Features
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#1A1A1A]">
            The columns readers wait a season for.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {FEATURES.map((f, i) => (
            <motion.article
              key={f.title}
              data-testid={f.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="relative overflow-hidden border border-[#2E1A6B]/20 group"
            >
              <img
                src={f.img}
                alt={f.title}
                className="w-full h-[420px] md:h-[560px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2AC1E0] mb-3">
                  {f.tag}
                </div>
                <h3 className="font-display text-white text-3xl md:text-4xl leading-[1.05] tracking-tight max-w-md">
                  {f.title}
                </h3>
                <p className="mt-4 text-white/85 text-sm md:text-base max-w-lg leading-relaxed">
                  {f.copy}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-white">
                  Read the diaries <ArrowUpRight size={16} />
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
